export default __webpack_public_path__ + "static/media/040_tunnel.5f680d76.mp3";